import React, { useState } from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
`;

const Header = styled.div`
    display: flex;
`;

const Info = styled.div`
    display: flex;
    width: 50%;
    flex-direction: column;
`;

const Count = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
`;

const BulletinTitle = styled.div`
    width: 100%;
    text-align: center;
    font-size: 24px;
    padding: 20px;
`;

const BulletinDescription = styled.div`
    display: block;

    img {
        display: block;
        max-width: 100%;
        height: auto;
    }
`;

const CountTitle = styled.div`
    width: 100%;
    text-align: center;
    font-size: 24px;
    padding: 20px;
`;

const ChartWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const ChartPercentage = styled.div`
    margin: 3px;
    padding: 3px 6px;
    border-radius: 3px;
    background-color: #fff;
    font-weight: bolder;
    position: absolute;
    border: 1px solid #007176;
`;

const ChartProgress = styled.div`
    border-radius: 3px;
    background-color: #03bfc745;
    width: 100%;
    min-height: 50px;
`;

const ChartProgressStats = styled.div`
    border-radius: 3px;
    background-color: ${props => props.color};
    width: ${props => props.width}%;
    min-height: 100%;
`;

const Question = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    text-align: left;
`;

const QuestionNumber = styled.div``;

const QuestionName = styled.div`
    width: 100%;
`;

const AnswerWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 6px;
    border-radius: 3px;

    &:hover {
        background-color: lightblue;
        cursor: pointer;
    }
`;

const Circle = styled.i(props => ({
    color: props.color
}));

const AnswerName = styled.div`
    width: 50%;
    position: relative;
    cursor: pointer;
`;

const AnswerStats = styled.div`
    display: flex;
    width: 50%;
    text-align: center;
`;

const AnswerChartWrapper = styled.div`
    width: 50%;
`;

const AnswerText = styled.div`
    display: flex;
    font-weight: bolder;
    padding: 0 10px;
    width: 50%;
`;

const AnswerChart = styled.div`
    padding: 2px;
    border-radius: 3px;
    background-color: ${props => props.color};
    width: ${props => props.width}%;
    height: 100%;
`;

const Popover = styled.div`
    position: absolute;
    z-index: 10;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    max-width: 300px;
    max-height: 200px;
    overflow-y: auto;
    top: 100%;
    left: 0;
`;

const VotingBulletinCommonPublicReport = ({ common_report_stat_json, colors_pallet }) => {
    const [popoverIndex, setPopoverIndex] = useState(null);

    const declOfNum = (number, words) => {
        return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
    };

    const togglePopover = (questionIndex, answerIndex) => {
        const key = `${questionIndex}-${answerIndex}`;
        setPopoverIndex(popoverIndex === key ? null : key);
    };

    return (
        <Wrapper>
            <Header>
                <Info>
                    <BulletinTitle><strong>{common_report_stat_json.title}</strong></BulletinTitle>
                    <BulletinDescription dangerouslySetInnerHTML={{ __html: common_report_stat_json.description }} />
                </Info>
                <Count>
                    <CountTitle>
                        <strong>
                            {declOfNum(common_report_stat_json.total_votes, ['Проголосовал', 'Проголосовали', 'Проголосовали'])}
                            {common_report_stat_json.total_votes} из {common_report_stat_json.users_can_vote}
                            {declOfNum(common_report_stat_json.users_can_vote, ['жителя', 'жителей', 'жителей'])}
                        </strong>
                    </CountTitle>
                    <ChartWrapper>
                        <ChartPercentage>
                            {common_report_stat_json.total_votes_percentage}%
                        </ChartPercentage>
                        <ChartProgress>
                            <ChartProgressStats
                                width={common_report_stat_json.total_votes_percentage}
                                color={'#03BFC7'}
                            />
                        </ChartProgress>
                    </ChartWrapper>
                </Count>
            </Header>

            {common_report_stat_json.voting_questions.map((voting_question, qIndex) => (
                <Question key={qIndex}>
                    <QuestionNumber><strong>Вопрос № {qIndex + 1}</strong></QuestionNumber>
                    <QuestionName dangerouslySetInnerHTML={{ __html: voting_question.name }} />

                    {voting_question.voting_answers.map((voting_answer, aIndex) => (
                        <AnswerWrapper key={aIndex}>
                            <AnswerName onClick={() => togglePopover(qIndex, aIndex)}>
                                <Circle color={colors_pallet[aIndex]} className="fas fa-circle"></Circle>&nbsp;
                                {voting_answer.name}
                                {popoverIndex === `${qIndex}-${aIndex}` && voting_answer.user_addresses && voting_answer.user_addresses.length > 0 && (
                                    <Popover>
                                        <div><strong>Проголосовавшие участки №:</strong></div>
                                        {voting_answer.user_addresses.map((address, i) => (
                                            <div key={i}>{address}</div>
                                        ))}
                                    </Popover>
                                )}
                            </AnswerName>

                            {voting_answer.vote_count > 0 ? (
                                <AnswerStats>
                                    <AnswerChartWrapper>
                                        <AnswerChart
                                            width={common_report_stat_json.voice_weight
                                                ? voting_answer.percentage_with_voice_weight
                                                : voting_answer.percentage}
                                            color={colors_pallet[aIndex]}
                                        />
                                    </AnswerChartWrapper>
                                    <AnswerText>
                                        {common_report_stat_json.voice_weight
                                            ? `${voting_answer.percentage_with_voice_weight}% - ${voting_answer.vote_count_with_voice_weight} `
                                            : `${voting_answer.percentage}% - ${voting_answer.vote_count} `}
                                        {declOfNum(
                                            common_report_stat_json.voice_weight
                                                ? voting_answer.vote_count_with_voice_weight
                                                : voting_answer.vote_count,
                                            ['голос', 'голоса', 'голосов']
                                        )}
                                    </AnswerText>
                                </AnswerStats>
                            ) : (
                                <AnswerStats>
                                    <AnswerText>нет голосов</AnswerText>
                                </AnswerStats>
                            )}
                        </AnswerWrapper>
                    ))}
                </Question>
            ))}
        </Wrapper>
    );
};

export default VotingBulletinCommonPublicReport;
